"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.TOURNAMENT_COMMANDS = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _DataStore = _interopRequireWildcard(require("./../KESI2/Stores/DataStore2"));

var _AppUtils = require("./../utils/AppUtils");

var _AblyMessagingCommands = require("../common/constants/AblyMessagingCommands");

var _QuizTournament = _interopRequireWildcard(require("../common/components/Equizzer/QuizTournament"));

var _RestService = _interopRequireDefault(require("../common/components/Equizzer/services/RestService"));

var _GameService = _interopRequireDefault(require("../common/components/Equizzer/services/GameService"));

var _NavigationManager = _interopRequireDefault(require("../common/NavigationManager"));

var _ArrayHelper = require("../helpers/ArrayHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("./../helpers/DeviceInfoHelper"));

var TOURNAMENT_COMMANDS = {
  TOURNAMENTS_UPDATE: 'tournamentsUpdate',
  MY_TOURNAMENT_UPDATE: 'myTournamentUpdate'
};
exports.TOURNAMENT_COMMANDS = TOURNAMENT_COMMANDS;
var MAX_AGE_ROUND_PLAYED_MESSAGE = 5000;
var INSTANCE = null;
/*
This class is supposed to always have the most up to date tournament data.
 */

var TournamentStateHelper = /*#__PURE__*/function () {
  function TournamentStateHelper() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, TournamentStateHelper);
    (0, _defineProperty2["default"])(this, "reloadTournamentData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var userAuth, myTournamentId, userGroup, tournaments, myTournament;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userAuth = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH_AUTH);
              myTournamentId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT_ID);
              _context.prev = 2;
              // TODO Group might not be there, check before deploying next tournament app
              userGroup = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP);
              console.log('TournamentStateHelper Usergroup', userGroup);

              if (!(userGroup && userGroup.hasTournament)) {
                _context.next = 19;
                break;
              }

              _context.next = 8;
              return _GameService["default"].loadTournaments(userAuth);

            case 8:
              tournaments = _context.sent;
              _context.next = 11;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS, tournaments);

            case 11:
              _this.callTournamentListeners(TOURNAMENT_COMMANDS.TOURNAMENTS_UPDATE);

              if (!myTournamentId) {
                _context.next = 19;
                break;
              }

              _context.next = 15;
              return _GameService["default"].loadSpecificTournament(userAuth, myTournamentId);

            case 15:
              myTournament = _context.sent;
              _context.next = 18;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, myTournament);

            case 18:
              _this.callTournamentListeners(TOURNAMENT_COMMANDS.MY_TOURNAMENT_UPDATE);

            case 19:
              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](2);
              console.error('Error: TournamentStateHelper, reloadTournamentData', _context.t0);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 21]]);
    })));
    (0, _defineProperty2["default"])(this, "handleRoundPlayed", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(message) {
        var tournamentId, teamPoints, currentTournament, teams;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!message.data) {
                  _context2.next = 12;
                  break;
                }

                tournamentId = message.data.tournamentId;
                teamPoints = message.data.teamPoints;

                if (!(tournamentId && teamPoints)) {
                  _context2.next = 12;
                  break;
                }

                currentTournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT);

                if (!(currentTournament.id && tournamentId === currentTournament.id)) {
                  _context2.next = 12;
                  break;
                }

                if (!(message.timestamp && (0, _now["default"])() - message.timestamp > MAX_AGE_ROUND_PLAYED_MESSAGE)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", _this.reloadTournamentData());

              case 8:
                teams = currentTournament.teams;
                (0, _keys["default"])(teamPoints).forEach(function (teamName) {
                  teams[teamName].points = teamPoints[teamName];
                });
                _context2.next = 12;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, currentTournament);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "handleTournamentUpdate", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(message) {
        var tournament, currentTournament;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!message.data) {
                  _context3.next = 9;
                  break;
                }

                tournament = message.data;
                _context3.next = 4;
                return _this.updateTournament(tournament);

              case 4:
                currentTournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT);

                if (!(tournament.id && currentTournament.id && tournament.id === currentTournament.id)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 8;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, tournament);

              case 8:
                _this.callTournamentListeners(TOURNAMENT_COMMANDS.MY_TOURNAMENT_UPDATE);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "handleTournamentStart", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(message) {
        var currentTournaments, tournament, updatedTournaments, data;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!message.data) {
                  _context4.next = 11;
                  break;
                }

                currentTournaments = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS) || [];
                tournament = message.data;

                if (!(currentTournaments.map(function (currentTournament) {
                  return currentTournament.id;
                }).indexOf(tournament.id) < 0)) {
                  _context4.next = 11;
                  break;
                }

                updatedTournaments = currentTournaments.concat(tournament);
                data = {};
                data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS] = updatedTournaments; // no need to check if that just started tournament is still open

                data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE] = true;
                _context4.next = 10;
                return _DataStore["default"].setData(data, false);

              case 10:
                // no need to check if that just started tournament is still open
                _this.callTournamentListeners(TOURNAMENT_COMMANDS.TOURNAMENTS_UPDATE);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    this.reloadTournamentData();

    _DeviceInfoHelper["default"].addOnlineListener(this.reloadTournamentData);

    (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.ROUND_PLAYED, this.handleRoundPlayed);
    (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.TOURNAMENT_UPDATE, this.handleTournamentUpdate);
    (0, _AppUtils.registerForAblyMessagesWithcommand)(_AblyMessagingCommands.ABLY_COMMANDS.TOURNAMENT_START, this.handleTournamentStart);
    this.listeners = {};
  }

  (0, _createClass2["default"])(TournamentStateHelper, [{
    key: "updateTournament",
    value: function () {
      var _updateTournament = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(tournament) {
        var tournaments, index;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                tournaments = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS) || [];
                index = tournaments.map(function (currentTournament) {
                  return currentTournament.id;
                }).indexOf(tournament.id);

                if (!(index > -1)) {
                  _context5.next = 7;
                  break;
                }

                tournaments[index] = tournament;
                _context5.next = 6;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS, tournaments, false);

              case 6:
                this.callTournamentListeners(TOURNAMENT_COMMANDS.TOURNAMENTS_UPDATE);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateTournament(_x4) {
        return _updateTournament.apply(this, arguments);
      }

      return updateTournament;
    }()
  }, {
    key: "addTournamentListener",
    value: function addTournamentListener(command, callback) {
      if (!this.listeners[command]) {
        this.listeners[command] = [];
      }

      if (this.listeners[command].indexOf(callback) < 0) {
        this.listeners[command].push(callback);
      }
    }
  }, {
    key: "callTournamentListeners",
    value: function callTournamentListeners(command) {
      console.log('call tournamentlisteners: ', this.listeners);

      if (this.listeners[command]) {
        this.listeners[command].forEach(function (callback) {
          callback();
        });
      }
    }
  }, {
    key: "removeTournamentListener",
    value: function removeTournamentListener(command, callback) {
      if (this.listeners[command]) {
        (0, _ArrayHelper.removeElement)(this.listeners[command], callback);
      }
    }
  }], [{
    key: "instance",
    value: function instance() {
      if (!INSTANCE) {
        INSTANCE = new TournamentStateHelper();
      }

      return INSTANCE;
    }
  }, {
    key: "setupInitialState",
    value: function () {
      var _setupInitialState = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var user,
            userAuth,
            userToUse,
            userAuthToUse,
            groupObject,
            tournaments,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                user = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
                userAuth = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
                userToUse = user;
                userAuthToUse = userAuth;
                _context6.prev = 4;

                if (!(!userToUse || !userAuthToUse)) {
                  _context6.next = 11;
                  break;
                }

                userToUse = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER);
                userAuthToUse = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH_AUTH);

                if (!(!userToUse || !userAuthToUse)) {
                  _context6.next = 11;
                  break;
                }

                console.log('unable to execute setupInitialstate');
                return _context6.abrupt("return");

              case 11:
                if (!userToUse.playgroupId) {
                  _context6.next = 31;
                  break;
                }

                _context6.next = 14;
                return _RestService["default"].getGroup([userToUse.playgroupId], userAuthToUse);

              case 14:
                groupObject = _context6.sent;
                console.log('TOURNAMENTSTATEHELPER: ', userToUse, userToUse.id, userAuthToUse, groupObject, groupObject.value, groupObject.value.hasTournaments);

                if (!(groupObject.value && groupObject.value.hasTournaments)) {
                  _context6.next = 26;
                  break;
                }

                if (!(userToUse && userToUse.id && userAuthToUse)) {
                  _context6.next = 24;
                  break;
                }

                _context6.next = 20;
                return _GameService["default"].loadTournaments(userAuthToUse);

              case 20:
                tournaments = _context6.sent;
                console.log('group has tournaments', tournaments);
                _context6.next = 24;
                return TournamentStateHelper.handleTournamentListResponse(tournaments);

              case 24:
                _context6.next = 31;
                break;

              case 26:
                console.log('data store // tournament', _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_SUPPORTS_TOURNAMENTS), _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE));
                _context6.next = 29;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_SUPPORTS_TOURNAMENTS, false, true);

              case 29:
                _context6.next = 31;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE, false, false);

              case 31:
                _context6.next = 36;
                break;

              case 33:
                _context6.prev = 33;
                _context6.t0 = _context6["catch"](4);
                console.log('error setupInitialState', _context6.t0);

              case 36:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[4, 33]]);
      }));

      function setupInitialState() {
        return _setupInitialState.apply(this, arguments);
      }

      return setupInitialState;
    }()
    /*
    Used as queue callback in GameService. (Because calling setupInitialState in App.js, deviceready, caused an OFFLINE_ERROR)
    */

  }, {
    key: "handleTournamentListResponse",
    value: function () {
      var _handleTournamentListResponse = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(tournaments) {
        var user, hasRunningTournament, myTournament, myTournamentUpdated, info, data;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                user = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER);
                hasRunningTournament = _QuizTournament["default"].searchForRunningTournaments(tournaments, user.id);
                _context7.next = 4;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_SUPPORTS_TOURNAMENTS, true, true);

              case 4:
                myTournament = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT);

                if (!(myTournament && myTournament.id)) {
                  _context7.next = 12;
                  break;
                }

                myTournamentUpdated = tournaments.find(function (tournament) {
                  return tournament.id === myTournament.id;
                });

                if (!myTournamentUpdated) {
                  _context7.next = 10;
                  break;
                }

                _context7.next = 10;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, myTournamentUpdated);

              case 10:
                _context7.next = 16;
                break;

              case 12:
                info = _QuizTournament["default"].getTournamentDataIfMember(tournaments, user.id);

                if (!info) {
                  _context7.next = 16;
                  break;
                }

                _context7.next = 16;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, info.tournament);

              case 16:
                if (!hasRunningTournament) {
                  _context7.next = 23;
                  break;
                }

                data = {};
                data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENTS] = tournaments;
                data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_IS_ACTIVE] = true;
                _context7.next = 22;
                return _DataStore["default"].setData(data, false);

              case 22:
                if ((0, _typeof2["default"])(hasRunningTournament) === 'object') {
                  _NavigationManager["default"].goToTournamentStart(true);
                }

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function handleTournamentListResponse(_x5) {
        return _handleTournamentListResponse.apply(this, arguments);
      }

      return handleTournamentListResponse;
    }()
  }, {
    key: "addTournamentListener",
    value: function addTournamentListener(command, callback) {
      TournamentStateHelper.instance().addTournamentListener(command, callback);
    }
  }, {
    key: "removeTournamentListener",
    value: function removeTournamentListener(command, callback) {
      TournamentStateHelper.instance().removeTournamentListener(command, callback);
    }
  }, {
    key: "reloadTournamentData",
    value: function () {
      var _reloadTournamentData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return TournamentStateHelper.instance().reloadTournamentData();

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function reloadTournamentData() {
        return _reloadTournamentData.apply(this, arguments);
      }

      return reloadTournamentData;
    }()
  }]);
  return TournamentStateHelper;
}();

var _default = TournamentStateHelper;
exports["default"] = _default;